import React, { useEffect, useState } from "react";
import apiClient from "../utils/axios";
import { KITCHEN } from "../config/api";
import toast from "react-hot-toast";

function Kitchen() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch order items
  const fetchItems = async () => {
    try {
      const { data } = await apiClient.get(KITCHEN.ORDERS);
      setItems(data);
    } catch (err) {
      console.error("Error fetching kitchen orders", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch kitchen orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // Mark item prepared
  const markPrepared = async (id) => {
    try {
      await apiClient.patch(KITCHEN.MARK_PREPARED(id));

      toast.success("Item marked as prepared");
      setItems((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, status: "prepared" } : item
        )
      );
    } catch (err) {
      console.error("Error marking item prepared", err);
      toast.error(err.response?.data?.message || err.message || "Failed to mark item as prepared");
    }
  };

  if (loading) return <p>Loading kitchen orders...</p>;

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#1e1e2f",
        color: "#f0f0f0",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        padding: "20px",
      }}
    >
      <h1 style={{ marginBottom: "20px", color: "#fff" }}>Kitchen Dashboard</h1>

      {items.length === 0 ? (
        <p style={{ color: "#aaa", fontSize: "16px" }}>No pending items 🎉</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: "20px",
          }}
        >
          {items.filter((item) => item.status === "pending").map((item) => (
            <div
              key={item._id}
              style={{
                backgroundColor: "#2c2c3c",
                borderRadius: "12px",
                padding: "20px",
                boxShadow:
                  item.status === "prepared"
                    ? "0 4px 15px rgba(40, 167, 69, 0.4)"
                    : "0 4px 15px rgba(0, 0, 0, 0.3)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "transform 0.2s, box-shadow 0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div>
                <h3 style={{ margin: "0 0 10px 0", color: "#fff" }}>
                  Table: {item.order_id?.table_id?.table_id || "N/A"}
                </h3>
                <p
                  style={{
                    margin: "5px 0",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {item.menu_item?.name}
                </p>
                <p style={{ margin: "5px 0", color: "#ccc" }}>
                  Quantity: {item.quantity}
                </p>
                <span
                  style={{
                    display: "inline-block",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    backgroundColor:"#494f4bff",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  {item.status.toUpperCase()}
                </span>
              </div>

              {item.status !== "prepared" && (
                <button
                  onClick={() => markPrepared(item._id)}
                  disabled={loading}
                  style={{
                    padding: "10px 15px",
                    marginTop: "15px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    fontWeight: "bold",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#218838")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#28a745")
                  }
                >
                  {loading ? "Updating..." : "Mark Prepared"}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Kitchen;
